package org.olafneumann.regex.generator.output

import org.olafneumann.regex.generator.regex.RegexCache

class RubyCodeGenerator : SimpleReplacingCodeGenerator(
    languageName = "Ruby",
    highlightLanguage = "ruby",
    templateCode = """def use_regex(input)
    regex = Regexp.new('%1${'$'}s'%2${'$'}s)
    regex.match input
end"""
) {

    override fun transformPattern(pattern: String): String =
        pattern.replace(RegexCache.get("([\\\\'])"), "\\\\$1").replace(RegexCache.get("\t"), "\\t")

    override fun generateOptionsCode(options: CodeGeneratorOptions) =
        options.combine(
            valueForCaseInsensitive = "Regexp::IGNORECASE",
            valueForDotAll = "Regexp::MULTILINE",
            separator = " | ",
            prefix = ", "
        )

    override fun getWarnings(pattern: String, options: CodeGeneratorOptions): List<String> {
        val warnings = mutableListOf<String>()
        if (options.multiline)
            warnings += "The Ruby regex engine does not support the MULTILINE option. " +
                    "Regex' are always treated as multiline."
        if (options.dotMatchesLineBreaks)
        // https://riptutorial.com/regex/example/18156/dotall-modifier
            warnings += "In Ruby, the DOTALL modifier equivalent is m, Regexp::MULTILINE modifier."

        return warnings
    }
}
